// oxlint-disable require-await
import {BasicDataResourceToMutatorsMap} from '@/modules/basic-data/constants'
import {useZero} from '@/shared/integrations/zero/use-zero'
import {DeleteResourceSchema} from '@cypro/engine/mutators/util'
import {BasicDataResources} from '@cypro/engine/schema'
import {DeleteResourceDialog, dialog} from '@cypro/ui/components'
import {useTranslate} from '@tolgee/react'
import {useCallback} from 'react'
import * as z from 'zod'
const DeleteBasicDataSchema = DeleteResourceSchema.extend({
  resource: z.enum(Object.values(BasicDataResources)),
})
type DeleteBasicDataSchema = z.infer<typeof DeleteBasicDataSchema>

export function useDeleteBasicData() {
  const zero = useZero()

  return useCallback(
    async (payload: DeleteBasicDataSchema) => {
      const mutators = payload.resource ? BasicDataResourceToMutatorsMap[payload.resource] : undefined
      if (!mutators) throw new Error('Mutators is undefined')

      return zero.attemptMutation(mutators.delete(payload), async mutation => await mutation.server)
    },
    [zero]
  )
}

export function useConfirmDeleteBasicData() {
  const {t: tConsumables} = useTranslate('consumables')
  const deleteConsumable = useDeleteBasicData()

  return useCallback(
    async (payload: DeleteBasicDataSchema) => {
      const confirmed = await dialog.open(payload.id, {
        children: (
          <DeleteResourceDialog
            id={payload.id}
            title={tConsumables('delete_basic_data_dialog.title')}
            description={tConsumables('delete_basic_data_dialog.description')}
          />
        ),
      })
      if (!confirmed) throw new Error('User did not confirm')

      const deleteRes = await deleteConsumable(payload)

      if (!deleteRes) throw new Error('Unexpected error')
      if (deleteRes.type === 'error') throw deleteRes.error
    },
    [tConsumables, deleteConsumable]
  )
}
